import React from 'react';
import {PopoverMenuOptionProps} from "./option";
import ProjectTypeIcon from "../../../../../../gd-components/icons/project/project-type-icon/project-type-icon";

export default function OptionText(props:PopoverMenuOptionProps) {

    const onClick = () => {
        if (!props.option.disabled) props.onClick(props.option);
    }

    const classes = Classes('option', {
        'highlighted'   : props.isHighlighted,
        'is-selected'   : props.isSelected,
        disabled        : props.option.disabled
    })

    const valueClass = Classes('label', {
        bold: props.isSelected,
    })

    const style : style = props.option.description ? {
        height      : 'unset',
        minHeight   : '36',
        whiteSpace  : 'normal',
    } : {}

    return (
        <div className={classes} style={style} onClick={onClick}>
            <div className="flex-column-left-top w-100-percent m-t-8 m-b-8">
                <div className="flex-row-left-center flex-wrap w-100-percent ui5-txt-no-accent-tiny">
                    <ProjectTypeIcon className="m-r-8" projectId={props.option.value}/>
                    <div className={valueClass}>{props.option.label}</div>
                </div>

                {!!props.option.description &&
                    <div className="flex-row-left-center w-100-percent ui5-txt-no-accent-tiny m-t-5" style={{lineHeight: '140%'}}>
                        {props.option.description}
                    </div>}
            </div>
        </div>
    )
}
